import React from "react";
import { Box, Typography } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";

interface DragInDropZoneImageProps {
  disabled: boolean;
  isView: boolean;
  imageFileName?: string | null;
  onUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: () => void;
}

const DragInDropZoneImage: React.FC<DragInDropZoneImageProps> = ({
  disabled,
  isView,
  imageFileName,
  onUpload,
  onRemoveFile,
}) => {
  const [isDragging, setIsDragging] = React.useState(false);
  const inputId = "notification-image-upload";

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    if (disabled) return;
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    if (disabled) return;
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    if (disabled) return;
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const file = e.dataTransfer.files?.[0];
    if (!file) return;

    const fakeEvent = ({
      target: { files: [file] },
    } as unknown) as React.ChangeEvent<HTMLInputElement>;

    onUpload(fakeEvent);
  };

  return (
    <Box>
      <input
        id={inputId}
        type="file"
        accept="image/png,image/jpeg,image/webp"
        style={{ display: "none" }}
        onChange={onUpload}
        disabled={disabled}
      />

      <label htmlFor={inputId}>
        <Box
          sx={{
            border: "1px dashed",
            borderColor: isView
              ? "#E5DED7"
              : isDragging
              ? "#D91F05"
              : "#D2D2D2",
            borderRadius: 1,
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: isView ? "default" : "pointer",
            mb: 1.5,
            bgcolor: isView ? "#E5DED7" : isDragging ? "#FFF3F0" : "#FFFFFF",
            transition: "all 0.2s ease",
            boxShadow: isDragging ? "0 0 0 2px rgba(217,31,5,0.2)" : "none",
            transform: isDragging ? "scale(1.01)" : "scale(1)",
          }}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <Typography
            sx={{
              fontSize: 14,
              color: isView ? "#999999" : isDragging ? "#D91F05" : "#666666",
            }}
          >
            {isDragging
              ? "Solte o arquivo aqui para enviar"
              : "Arraste aqui ou clique no ícone para selecionar"}
          </Typography>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1,
              border: "1px solid #D91F05",
              bgcolor: isView ? "#E5DED7" : isDragging ? "#FFFFFF" : "#D91F05",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
          >
            <ImageIcon
              sx={{
                color: isView ? "#D91F05" : isDragging ? "#D91F05" : "#FFFFFF",
              }}
            />
          </Box>
        </Box>
      </label>

      <Typography sx={{ fontSize: 12, color: "#999999" }}>
        Formatos suportados: .png, .jpg, .jpeg, .webp.
      </Typography>

      {!!imageFileName && (
        <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
          <Typography sx={{ color: "#D91F05", fontSize: 14, mr: 1 }}>
            {imageFileName}
          </Typography>
          {!isView && (
            <Typography
              component="span"
              sx={{
                color: "#D91F05",
                fontSize: 14,
                cursor: "pointer",
              }}
              onClick={onRemoveFile}
            >
              X
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default DragInDropZoneImage;
